import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'หน้าหลัก',
        // roles: ['admin'], //
        breadcrumb: [
          {
            text: 'หน้าหลัก',
            active: true,
          },
        ],
      },
    },
    {
      path: '/addnamelist',
      name: 'addnamelist',
      component: () => import('@/views/reservation/addnamelist.vue'),
      meta: {
        pageTitle: 'จองคิวศูนย์',
        // roles: ['admin'], //
        breadcrumb: [
          {
            text: 'ลงทะเบียนข้อมูลแรงงาน',
            active: true,
          },
        ],
      },
    },
    {
      path: '/namelist',
      name: 'namelist',
      component: () => import('@/views/reservation/namelist.vue'),
      meta: {
        pageTitle: 'จองคิวศูนย์ด้วยไฟล์',
        // roles: ['admin'], //
        breadcrumb: [
          {
            text: 'ลงทะเบียนข้อมูลแรงงาน',
            active: true,
          },
        ],
      },
    },

    {
      path: '/report',
      name: 'reportlist',
      component: () => import('@/views/report/report.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'รายงานคิวที่จอง',
        // roles: ['admin'], //
        breadcrumb: [
          {
            text: 'รายงานคิวที่จอง',
            active: true,
          },
        ],
      },
    },
    {
      path: '/paymentreport',
      name: 'paymentreport',
      component: () => import('@/views/paymentreport.vue'),
      meta: {
        requiresAuth: true,
        //   roles: ['staff'], // ให้เฉพาะ staff เข้าถึง
        pageTitle: 'รายงานการชำระเงิน',
        breadcrumb: [
          {
            text: 'รายงานการชำระเงิน',
            active: true,
          },
        ],
      },
    },
    //user
    {
      path: '/search',
      name: 'search',
      component: () => import('@/views/reservation/search.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'อัพเดทคิวด่านชายแดน',
        // roles: ['admin'], //
        breadcrumb: [
          {
            text: 'อัพเดทคิวด่านชายแดน',
            active: true,
          },
        ],
      },
    },

    {
      path: '/Editnamelist',
      name: 'Editnamelist',
      component: () => import('@/views/reservation/Editnamelist.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'แก้ไขคิวศูนย์',
        // roles: ['admin'], //
        breadcrumb: [
          {
            text: 'แก้ไขคิวศูนย์',
            active: true,
          },
        ],
      },
    },
    {
      path: '/payment',
      name: 'payment',
      component: () => import('@/views/reservation/payment.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'จ่ายเงิน',
        // roles: ['admin'], //
        breadcrumb: [
          {
            text: 'จ่ายเงิน',
            active: true,
          },
        ],
      },
    },


    {
      path: '/updatenamelist',
      name: 'updatenamelist',
      component: () => import('@/views/reservation/updatenamelist.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'แก้ไขข้อมูลแรงงาน',
        breadcrumb: [
          {
            text: 'แก้ไขข้อมูลแรงงาน',
            active: true,
          },
        ],
      },
    },
    {
      path: '/updatequeue',
      name: 'updatequeue',
      component: () => import('@/views/reservation/updatequeue.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'อัพเดทคิว',
        navActiveLink: 'search',
        // roles: ['admin'], //
        breadcrumb: [
          {
            text: 'ค้นหา',
            // go: -1, // เมื่อคลิก breadcrumb นี้ จะ go back ไปหน้าก่อนหน้า
            to: '/search',
          },
          {
            text: 'อัพเดทคิว',
            active: true,
          },
        ],
      },
    },
    {
      path: '/user-list',
      name: 'userlist',
      component: () => import('@/views/user/User.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'เพิ่มเจ้าหน้าที่',
        // roles: ['admin'], //
        breadcrumb: [
          {
            text: 'เพิ่มเจ้าหน้าที่',
            active: true,
          },
        ],
      },
    },
    {
      path: '/addqueue',
      name: 'addqueue',
      component: () => import('@/views/reservation/addqueue.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'จองคิว',
        // roles: ['admin'], //
        navActiveLink: 'namelist',
        breadcrumb: [
          {
            text: 'จองคิว',
            // go: -1, // เมื่อคลิก breadcrumb นี้ จะ go back ไปหน้าก่อนหน้า
            to: '/namelist',
          },
          {
            text: 'เพิ่มคิว',
            active: true,
          },
        ],
      },
    },
    {
      path: '/booking',
      name: 'booking',
      component: () => import('@/views/booking.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/config',
      name: 'config',
      component: () => import('@/views/settingconfig/config.vue'),
      meta: {
        requiresAuth: true,
        // roles: ['admin'], //
        pageTitle: 'ข้อมูลด่านชายแดน',
        breadcrumb: [
          {
            text: 'ข้อมูลด่านชายแดน',
            active: true,
          },
        ],
      },
    },
    {
      path: '/workerscenter',
      name: 'workerscenter',
      component: () => import('@/views/settingconfig/workerscenter.vue'),
      meta: {
        requiresAuth: true,
        // roles: ['admin'], //
        pageTitle: 'ข้อมูลศูนย์แรงงานต่างด้าว',
        breadcrumb: [
          {
            text: 'ข้อมูลศูนย์แรงงานต่างด้าว',
            active: true,
          },
        ],
      },
    },
    {
      path: '/regiscompany',
      name: 'regiscompany',
      component: () => import('@/views/regiscompany.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/map/:latlon',
      name: 'map',
      component: () => import('@/views/maps/map.vue'),
      params: true,
      props: true,
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/mapall',
      name: 'mapall',
      component: () => import('@/views/maps/mapall.vue'),
      meta: {
         
      },
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: () => import('@/views/Login.vue'),
    //   meta: {
    //     layout: 'full',
    //   },
    // },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})


// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})
router.beforeEach((to, from, next) => {
  const userRole = localStorage.getItem('role')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  console.log(userRole)
  console.log(requiresAuth)
  // รวม roles จากทุก matched route meta
  const allowedRoles = to.matched.reduce((acc, record) => {
    if (record.meta && record.meta.roles) {
      acc = acc.concat(record.meta.roles)
    }
    return acc
  }, [])

  if (requiresAuth) {
    if (!userRole) {
      return next({ name: 'login' })
    }
    console.log(allowedRoles)
    if (allowedRoles.length > 0) {
      if (allowedRoles.includes(userRole)) {
        return next() // role ตรง -> ผ่าน
      } else {
        return next({ name: 'error-404' }) // role ไม่ตรง -> ไป 404
      }
    }
  }

  next()
})
export default router
